const seconds_in_hours = 60 * 60;
export const prettyDuration = (inpSeconds: number): string => {
  const hours = Math.floor(inpSeconds / seconds_in_hours);
  const inspecondsWoHours = inpSeconds % seconds_in_hours;
  const minutes = Math.floor(inspecondsWoHours / 60);
  const rawSeconds = inspecondsWoHours % 60;
  let seconds = Number(rawSeconds.toFixed(2));
  let adjustedMinutes = minutes;
  let adjustedHours = hours;

  if (seconds >= 60) {
    seconds -= 60;
    adjustedMinutes += 1;
  }
  if (adjustedMinutes >= 60) {
    adjustedMinutes -= 60;
    adjustedHours += 1;
  }

  if (adjustedHours > 0) {
    return `${adjustedHours}h ${adjustedMinutes}m ${seconds}s`;
  }
  if (adjustedMinutes > 0) {
    return `${adjustedMinutes}m ${seconds}s`;
  }
  return `${seconds}s`;
};

// Example: 1234 -> 1.2
export const prettyDurationSeconds = (inpMs: number): string => {
  const seconds = Math.floor(inpMs / 1000);
  const milliseconds = Math.floor((inpMs % 1000) / 100);
  return [seconds > 0 && seconds, `${milliseconds}`].filter(Boolean).join('.');
};
